// extracted by mini-css-extract-plugin
export default {"container":"My404Component_container__4dipF","content":"My404Component_content__6Enqp"};